@let notes = (notes$ | async)!;
<p-drawer [(visible)]="notificationsSidebarVisible" position="right" class="notes-sidebar" styleClass="w-[30rem]">
  <ng-template #header>
    <h3 class="m-0 p-0">
      {{ 'chat.pendingNotifications' | translate | titlecase }}
      <p-tag [value]="$any(notes.length)" [rounded]="true">
        <ng-template #icon>
          <fa-icon [icon]="faBell"></fa-icon>
        </ng-template>
      </p-tag>
    </h3>
  </ng-template>

  @if (notes.length > 0) {
    <ul class="notificationContent">
      @for (note of notes; track note; let index = $index) {
        @if (showDayDivider(notes[index - 1], note)) {
          <li class="day-divider">
            {{ note?._metadata?.created | date: 'longDate' }}
          </li>
        }
        <li
          class="br-2 rounded-sm border border-[#dee2e6] p-2!"
          (mouseenter)="onNoteMouseEnter(note)"
          (mouseleave)="onNoteMouseLeave(note)"
        >
          <header class="flex items-center justify-between gap-2 pr-1" (click)="goTo(note)">
            <span class="metadata">
              <span>
                <b>{{ note?._metadata?.creator }}</b> {{ ' ' }}
                <i>{{ note?._metadata?.created | date: 'shortTime' }}</i>
              </span>
            </span>
            <fa-icon [icon]="getIconByCollection(note.collectie)"></fa-icon>
          </header>
          <p
            class="message"
            (click)="goTo(note)"
            [@expandCollapseMessage]="notesAnimationState.get(note.id) ? 'expanded' : 'collapsed'"
          >
            {{ note.bericht }}
          </p>
          <footer
            class="items-center justify-end gap-2"
            [@expandCollapseFooter]="notesAnimationState.get(note.id) ? 'expanded' : 'collapsed'"
          >
            <p-checkbox
              [pTooltip]="'chat.readHelp' | translate"
              [binary]="true"
              inputId="readed"
              styleClass="p-checkbox-sm"
              (onChange)="markAsRead($event, note)"
            ></p-checkbox>
          </footer>
        </li>
      }
    </ul>
  } @else {
    <span>{{ 'chat.noPendingNotifications' | translate }}</span>
  }
</p-drawer>
